<template>
  <!-- 목표 달성시 style="display: block;" 추가 -->
  <div class="dashboard-info">
    <div class="dashboard-info__title">
      <h3 class="title">신규 ABO 후원 현황</h3>
      <p class="description">* 신규가입 ABO의 구매실적 데이터는 다음 날 반영되며, 실시간 데이터를 확인하시려면 LOS MAP을 확인해주세요.</p>
    </div>

    <!-- 가입자 정보가 없을 경우 -->
    <div class="dashboard-info__nodata" v-if="abocardlist.length === 0">
      <i class="no-data-icon"></i>
      <p class="no-data-text" v-if="deadline === 'Y'">신규 ABO 가입자 정보가 없습니다.</p>
      <p class="no-data-text" v-else>현재 데이터 마감 중으로 중순 이후부터 조회가 가능합니다. 감사합니다.</p>
    </div>

    <!-- // 가입자 정보가 없을 경우 -->
    <div class="dashboard-info__card" v-if="abocardlist">
      <div class="dashboard-info__card-item" v-for="(abo, index) in abocardlist" :key="index">
        <div class="card-inner" v-bind:class="{'none': abo.amt === 0}">
          <div class="title">
            <span class="num">{{index+1}}</span>
            <span class="name">{{abo.name}}</span>
            <span class="account">
              <template v-if="abo.privacy === 'Y'">({{abo.number}})</template>
              <template v-if="abo.privacy === 'N'">({{abo.number_mask}})</template>
            </span>
          </div>
          <div class="result">
            <div class="result__title">누적 구매금액</div>
            <div class="result__summary">
              <strong class="amount">{{abo.amt}}</strong>
              <span class="currency">원</span>
            </div>
          </div>
          <div class="graph">
            <div class="graph__inner" v-bind:style="{width: abo.persent + '%'}"></div>
          </div>
          <template v-if="abo.amt != '0'">
            <button type="button" class="detail-button" data-layer="orderHistory" @click="$emit('layer', 'orderHistory', abo.number, abo.name, abo.privacy)">주문내역</button>
          </template>
          <template v-else>
            <button type="button" class="detail-button" data-layer="orderHistory" disabled>주문내역</button>
          </template>
        </div>
      </div>
    </div>
  </div>
  <!-- // 목표 달성시 style="display: block;" 추가 -->
</template>
<script>
export default {
  props: ['abocardlist', 'deadline']
}
</script>
<style scoped>
@import '../assest/css/abo.css';
</style>



// WEBPACK FOOTER //
// src/views/sales/dashboard/component/abocardList.vue